import {Text} from '@dropbox/dig-components/typography';
import cx from 'classnames';
import {Link} from 'components/DSYS/Link';
import type {MouseEventHandler} from 'react';

import styles from './RoadmapInitiativeLink.module.css';

const JIRA_BROWSE_URL = 'https://dropbox.atlassian.net/browse/';

export const getRoadmapInitiativeJiraUrl = (jiraKey: string) =>
  `${JIRA_BROWSE_URL}${encodeURIComponent(jiraKey)}`;

export interface RoadmapInitiativeLinkProps {
  title: string;
  jiraKey: string;
  jiraUrl?: string | null;
  lines?: 1 | 2;
  isBold?: boolean;
  className?: string;
  ariaLabel?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

/** Canonical Roadmap initiative title and Jira-link presentation. */
export const RoadmapInitiativeLink = ({
  title,
  jiraKey,
  jiraUrl,
  lines = 2,
  isBold = false,
  className,
  ariaLabel,
  onClick,
}: RoadmapInitiativeLinkProps) => {
  const label = `${title} (${jiraKey})`;
  const content = (
    <span
      className={cx(styles.label, lines === 1 ? styles.singleLine : styles.multipleLines)}
      title={label}
    >
      {title}{' '}
      <Text tagName="span" size="xsmall" color="subtle" className={styles.jiraKey}>
        ({jiraKey})
      </Text>
    </span>
  );
  const resolvedJiraUrl = jiraUrl === undefined ? getRoadmapInitiativeJiraUrl(jiraKey) : jiraUrl;

  return (
    <Text size="small" isBold={isBold} className={cx(styles.root, className)}>
      {resolvedJiraUrl ? (
        <Link
          to={resolvedJiraUrl}
          openInNewTab
          rel="noreferrer"
          hasNoUnderline
          monochromatic
          showUnderlineOnHover
          className={styles.link}
          aria-label={ariaLabel ?? label}
          onClick={onClick}
        >
          {content}
        </Link>
      ) : (
        content
      )}
    </Text>
  );
};
